module.exports = "/static/media/message_icon.1eb737ba.svg";